export default {
  columns: {
    version: 'Version',
    signed_at: 'Signé le',
    internal_note: 'Note interne',
    signature_provider: 'Fournisseur de signature',
    file: 'Document',
    actions: 'Actions',
  },
  labels: {
    version: 'v{{version}}',
    no_history: 'Aucun historique de signature disponible',
    providers: {
      selfhosted: 'Auto-hébergé',
      yousign: 'Yousign',
    },
  },
  buttons: {
    preview: 'Aperçu',
    download: 'Télécharger',
  },
};
